// `handoff` — end this wizard and start another; shown only when it was
// refused (unsaved changes with `require_saved`).

import AutoStep from './AutoStep'
import type { StepProps } from './common'

export default function HandoffStep(props: StepProps) {
  return <AutoStep {...props} retryLabel="Continue" note="Save this record first, then continue." />
}
